import React, { createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';
import moment from 'moment';

export const DashboardContext = createContext();

const initialFilters = {

    merchant_id: [],
    courier_id: [],
    dateRange: {
        startDate: moment().subtract(1, 'month').toDate(),
        endDate: moment().add(0, 'month').toDate(),
    },
    // type: 1,
};
const tabOptions = [
    { label: "B2C", value: 1 },
    { label: "B2B", value: 2 },
    { label: "USER DASHBOARD", value: 3 },
];
export const DashboardContextProvider = ({ children }) => {
    const { user, setAlertMessage, setOpenAlert, setSeverity } = useContext(CommonContext);
    const navigate = useNavigate();

    const [filters, setFilters] = useState(initialFilters);
    const [activeTab, setActiveTab] = useState(tabOptions[0].value);
    const [addModal, setAddModal] = useState(false);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState({});
    const [allPandingSummary, setAllPandingSummary] = useState([]);
    const [allPickupPandingSummary, setAllPickupPandingSummary] = useState([]);
    const [allNotattemptedSummary, setAllNotattemptedSummary] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [firstPLoading, setFirstPLoading] = useState(false);
    const [firstNALoading, setFirstNALoading] = useState(false);
    const [firstPPLoading, setFirstPPLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [formDataTemp, setFormDataTemp] = useState({
        action: '',
        file: null,
    });
    const [allB2CUser, setAllB2CUser] = useState([]);
    const [allCards, setAllCards] = useState({});
    const [allCourierWiseUpload, setAllCourierWiseUpload] = useState([]);
    const [allCourierWisePerformance, setAllCourierWisePerformance] = useState([]);
    const [allShipmentPerformance, setAllShipmentPerformance] = useState([]);
    const [allPerformanceOverview, setAllPerformanceOverview] = useState([]);
    const [allTopNDRResponse, setAllTopNDRResponse] = useState([]);

    const [cardsLoading, setCardsLoading] = useState(false);
    const [courierWiseUploadLoading, setCourierWiseUploadLoading] = useState(false);
    const [courierWisePerformanceLoading, setCourierWisePerformanceLoading] = useState(false);
    const [shipmentPerformanceLoading, setShipmentPerformanceLoading] = useState(false);
    const [performanceOverviewLoading, setPerformanceOverviewLoading] = useState(false);
    const [ndrLoading, setNdrLoading] = useState(false);

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };
    const handlePanelOpen = () => {
        setIsPanelOpen(true);
    };

    const handlePanelClose = () => {
        setIsPanelOpen(false);
        setFormDataTemp({
            action: '',
            file: null,
        });
    };


    // console.log('filters', filters);
    const fetchCards = (payload) => {
        setCardsLoading(true);
        commonApi.post('/admin/dashboard/cards', payload)
            .then(res => {
                if (res.data?.s === 1) {
                    const data = res.data?.data?.cards || {};
                    setAllCards(data);
                    setAllData(prev => ({ ...prev, cards: data }));
                }
                setCardsLoading(false);
            })
            .catch(err => {
                console.error('Error fetching cards:', err);
                setCardsLoading(false);
            });
    };

    const fetchCourierWiseUpload = (payload) => {
        setCourierWiseUploadLoading(true);
        commonApi.post('/admin/dashboard/courier-wise-upload', payload)
            .then(res => {
                if (res.data?.s === 1) {
                    const data = res.data?.data?.courierWiseUpload || [];
                    setAllCourierWiseUpload(data);
                    setAllData(prev => ({ ...prev, courierWiseUpload: data }));
                }
                setCourierWiseUploadLoading(false);
            })
            .catch(err => {
                console.error('Error fetching courierWiseUpload:', err);
                setCourierWiseUploadLoading(false);
            });
    };

    const fetchCourierWisePerformance = (payload) => {
        setCourierWisePerformanceLoading(true);
        commonApi.post('/admin/dashboard/courier-wise-performance', payload)
            .then(res => {
                if (res.data?.s === 1) {
                    const data = res.data?.data?.courierWisePerformance || [];
                    setAllCourierWisePerformance(data);
                    setAllData(prev => ({ ...prev, courierWisePerformance: data }));
                }
                setCourierWisePerformanceLoading(false);
            })
            .catch(err => {
                console.error('Error fetching courierWisePerformance:', err);
                setCourierWisePerformanceLoading(false);
            });
    };

    const fetchShipmentPerformance = (payload) => {
        setShipmentPerformanceLoading(true);
        commonApi.post('/admin/dashboard/shipment-performance', payload)
            .then(res => {
                if (res.data?.s === 1) {
                    const data = res.data?.data?.ShipmentPerformance || [];
                    setAllShipmentPerformance(data);
                    setAllData(prev => ({ ...prev, ShipmentPerformance: data }));
                }
                setShipmentPerformanceLoading(false);
            })
            .catch(err => {
                console.error('Error fetching ShipmentPerformance:', err);
                setShipmentPerformanceLoading(false);
            });
    };

    const fetchPerformanceOverview = (payload) => {
        setPerformanceOverviewLoading(true);
        commonApi.post('/admin/dashboard/performance-overview', payload)
            .then(res => {
                if (res.data?.s === 1) {
                    const data = res.data?.data?.performanceOverview || [];
                    setAllPerformanceOverview(data);
                    setAllData(prev => ({ ...prev, performanceOverview: data }));
                }
                setPerformanceOverviewLoading(false);
            })
            .catch(err => {
                console.error('Error fetching performanceOverview:', err);
                setPerformanceOverviewLoading(false);
            });
    };

    const fetchNDR = (payload) => {
        setNdrLoading(true);
        commonApi.post('/admin/dashboard/ndr', payload)
            .then(res => {
                if (res.data?.s === 1) {
                    const data = res.data?.data?.TopNDRResponse || [];
                    setAllTopNDRResponse(data);
                    setAllData(prev => ({ ...prev, TopNDRResponse: data }));
                }
                setNdrLoading(false);
            })
            .catch(err => {
                console.error('Error fetching TopNDRResponse:', err);
                setNdrLoading(false);
            });
    };

    const onLoadApi = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        delete payload.dateRange;

        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id
        } else {
            payload.admin_id = user?.id
        }

        if (activeTab === 1) {
            setAllCards({});
            setAllCourierWiseUpload([]);
            setAllCourierWisePerformance([]);
            setAllShipmentPerformance([]);
            setAllPerformanceOverview([]);
            setAllTopNDRResponse([]);

            fetchCards(payload);
            fetchCourierWiseUpload(payload);
            fetchCourierWisePerformance(payload);
            fetchShipmentPerformance(payload);
            fetchPerformanceOverview(payload);
            fetchNDR(payload);
            setFirstLoading(true);

        } else {
            setAllData([]);
            setFirstLoading(false);

            setCardsLoading(true);
            setCourierWiseUploadLoading(true);
            setCourierWisePerformanceLoading(true);
            setShipmentPerformanceLoading(true);
            setPerformanceOverviewLoading(true);
            setNdrLoading(true);

            const url = '/admin/dashboard-b2b';
            commonApi.post(url, payload)
                .then((response) => {
                    setFirstLoading(true);
                    if (response?.data?.data) {
                        const data = response?.data?.data;
                        setAllData(data);
                        setAllCards(data.cards || {});
                        setAllCourierWiseUpload(data.courierWiseUpload || []);
                        setAllCourierWisePerformance(data.courierWisePerformance || []);
                        setAllShipmentPerformance(data.ShipmentPerformance || []);
                        setAllPerformanceOverview(data.performanceOverview || []);
                        setAllTopNDRResponse(data.TopNDRResponse || []);
                    }
                    setCardsLoading(false);
                    setCourierWiseUploadLoading(false);
                    setCourierWisePerformanceLoading(false);
                    setShipmentPerformanceLoading(false);
                    setPerformanceOverviewLoading(false);
                    setNdrLoading(false);
                })
                .catch((error) => {
                    setFirstLoading(true);
                    console.error('Error fetching B2B data:', error);
                    setCardsLoading(false);
                    setCourierWiseUploadLoading(false);
                    setCourierWisePerformanceLoading(false);
                    setShipmentPerformanceLoading(false);
                    setPerformanceOverviewLoading(false);
                    setNdrLoading(false);
                });
        }
    };


    const onExport = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = user?.id
        }
        delete payload.dateRange;
        setIsLoading(true);
        commonApi.post('/dashboard/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.message || 'Something went wrong');
                setSeverity('error')
            });
    };

    const onPendingLoadApi = (customFilters = filters) => {
        setAllPandingSummary([]);
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        delete payload.dateRange;

        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id
        } else {
            payload.admin_id = user?.id
        }
        setFirstPLoading(false);
        const url = activeTab === 1 ? '/admin/b2c-pending-summary' : '/admin/b2b-pending-summary';
        commonApi.post(url, payload)
            .then((response) => {
                setFirstPLoading(true);
                if (response?.data?.data) {
                    setAllPandingSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstPLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onPickupPendingLoadApi = (customFilters = filters) => {
        setAllPickupPandingSummary([]);
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        delete payload.dateRange;

        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id
        } else {
            payload.admin_id = user?.id
        }
        setFirstPPLoading(false);
        const url = activeTab === 1 ? '/admin/b2c-pickup-pending-summary' : '/admin/b2b-pickup-pending-summary';
        commonApi.post(url, payload)
            .then((response) => {
                setFirstPPLoading(true);
                if (response?.data?.data) {
                    setAllPickupPandingSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstPPLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onNotattemptedLoadApi = (customFilters = filters) => {
        setAllNotattemptedSummary([]);
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        delete payload.dateRange;

        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id
        } else {
            payload.admin_id = user?.id
        }
        setFirstNALoading(false);
        const url = activeTab === 1 ? '/admin/b2c-not-attempted-shipments' : '/admin/b2b-not-attempted-shipments';
        commonApi.post(url, payload)
            .then((response) => {
                setFirstNALoading(true);
                if (response?.data?.data) {
                    setAllNotattemptedSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstNALoading(true);
                console.error('Error fetching data:', error);
            });
    };


    const onPendingExport = (courierId = null, day = null) => {
        const payload = {
            ...filters,
            start_date: filters?.dateRange?.startDate
                ? format(new Date(filters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: filters?.dateRange?.endDate
                ? format(new Date(filters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        delete payload.dateRange;
        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id
        } else {
            payload.admin_id = user?.id
        }
        if (courierId) {
            payload.courier_id = courierId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            payload.date = date;
        }
        if (day === '45+') {
            const date = moment().subtract(45, 'days').format('YYYY-MM-DD');
            payload.date = date;
            payload.is_from = 1
        }
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
        setIsLoading(true);
        const url = activeTab === 1 ? '/admin/b2c-pending-summary/export' : '/admin/b2b-pending-summary/export';
        commonApi.post(url, payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMessage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };
    const onPickupPendingExport = (merchatId = null, courierId = null, day = null) => {
        const payload = {
            ...filters,
            start_date: filters?.dateRange?.startDate
                ? format(new Date(filters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: filters?.dateRange?.endDate
                ? format(new Date(filters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        delete payload.dateRange;
        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id
        } else {
            payload.admin_id = user?.id
        }
        if (merchatId) {
            payload.merchant_id = merchatId;
        }
        if (courierId) {
            payload.courier_id = courierId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            payload.date = date;
        }
        if (day === '10+') {
            const date = moment().subtract(10, 'days').format('YYYY-MM-DD');
            payload.date = date;
            payload.is_from = 1
        }
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
        setIsLoading(true);
        const url = activeTab === 1 ? '/admin/b2c-pickup-pending-summary/export' : '/admin/b2b-pickup-pending-summary/export';
        commonApi.post(url, payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMessage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };
    const onNotattemptedExport = (zoneId = null, day = null) => {
        const payload = {
            ...filters,
            start_date: filters?.dateRange?.startDate
                ? format(new Date(filters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: filters?.dateRange?.endDate
                ? format(new Date(filters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        delete payload.dateRange;
        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id
        } else {
            payload.admin_id = user?.id
        }
        if (zoneId) {
            payload.zone_category_id = zoneId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            payload.date = date;
        }
        if (day === '10+') {
            const date = moment().subtract(10, 'days').format('YYYY-MM-DD');
            payload.date = date;
            payload.is_from = 1
        }
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
        setIsLoading(true);
        const url = activeTab === 1 ? '/admin/b2c-not-attempted-shipments/export' : '/admin/b2b-not-attempted-shipments/export';
        commonApi.post(url, payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMessage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };

    const onB2CUserApi = (filter) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        if (filter?.user_id) {
            postReq.user_id = filter?.user_id
        } else {
            postReq.user_id = []
        }
        if (filter?.service_type) {
            postReq.service_type = filter?.service_type
        } else {
            postReq.service_type = '1'
        }
        if (filter?.dateRange) {
            postReq.start_date = filter?.dateRange.startDate ? moment(filter?.dateRange.startDate).format('YYYY-MM-DD') : ''
            postReq.end_date = filter?.dateRange.endDate ? moment(filter?.dateRange.endDate).format('YYYY-MM-DD') : ''
        } else {
            postReq.start_date = moment().startOf('month').format('YYYY-MM-DD')
            postReq.end_date = moment().endOf('month').format('YYYY-MM-DD')
            const dDateRange = {
                startDate: moment().startOf('month').toDate(),
                endDate: moment().endOf('month').toDate()
            };
            setFilters({ ...filters, dateRange: dDateRange });
        }
        setFirstLoading(false);
        commonApi.post('/admin/b2c-user-dashboard', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.s === 1) {
                    setAllB2CUser(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    // Fetch initial data when the context is created
    useEffect(() => {
        if (user && [1, 2].includes(activeTab)) {
            onLoadApi();
            onPickupPendingLoadApi();
            onPendingLoadApi();
            onNotattemptedLoadApi();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab, user]);


    const contextValue = {
        allCards,
        allCourierWiseUpload,
        allCourierWisePerformance,
        allShipmentPerformance,
        allPerformanceOverview,
        allTopNDRResponse,
        cardsLoading,
        courierWiseUploadLoading,
        courierWisePerformanceLoading,
        shipmentPerformanceLoading,
        performanceOverviewLoading,
        ndrLoading,
        allB2CUser,
        onB2CUserApi,
        allPandingSummary,
        allPickupPandingSummary,
        allNotattemptedSummary,
        firstPLoading,
        firstNALoading,
        firstPPLoading,
        onNotattemptedLoadApi,
        onPickupPendingLoadApi,
        onPendingLoadApi,
        onNotattemptedExport,
        onPickupPendingExport,
        onPendingExport,
        formDataTemp,
        setFormDataTemp,
        isPanelOpen,
        handlePanelOpen,
        handlePanelClose,
        onExport,
        addModal,
        handleAddModal,
        handleCloseModal,
        initialFilters,
        allData,
        setAllData,
        // allPriceCalculator,
        // setAllPriceCalculator,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
    };
    return (
        <DashboardContext.Provider value={contextValue}>
            {children}
        </DashboardContext.Provider>
    );
};

